import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIco from "../../../assets/icons/BackArrowIco";
import DeleteIco from "../../../assets/icons/DeleteIco";
import Breadcrumbs from "../../../component/Breadcrumbs";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar/index";
import {
  GetReferenceCheck,
  PutReferenceCheck,
} from "../../../redux/action/Job";
import { HandleSkeletion } from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import AddQuestion from "./components/AddQuestion";
import SkillDeleteDialog from "../../common-components/DeleteDialog";

export default function ReferenceCheck() {
  const query = new URLSearchParams(useLocation().search);
  const jobTitle = query.get("title");
  const jobId = query.get("id");
  const queryValue = query.get("value");
  const matchId = query.get("match-id");
  const candidateName = query.get("candidate-name");
  const navigate = useNavigate();
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    loading: false,
    content: "",
    index: null,
  });

  const [addQuestion, setAddQuestion] = useState({
    open: false,
    question: "",
    saveLoading: false,
    disabled: false,
  });
  const breadCrumbData = [
    {
      title: "Jobs",
      navigate: "/jobs",
    },
    {
      title: jobTitle,
      navigate: `/jobs/jobs-view?id=${jobId}&title=${jobTitle}&value=${queryValue}&match-id=${matchId}`,
    },
    {
      title: "Reference Check",
      active: true,
    },
  ];
  const [referenceCheck, setReferenceCheck] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    fetchInterviewKitData();
  }, [matchId]);

  const fetchInterviewKitData = async () => {
    setReferenceCheck((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const response = await GetReferenceCheck(matchId);
      setReferenceCheck((prev) => ({
        ...prev,
        data: response,
        loading: false,
      }));
    } catch (error) {
      console.log(error);
      setReferenceCheck((prev) => ({
        ...prev,
        error: error,
        loading: false,
      }));
      setSnackbarState((prev) => ({
        ...prev,
        message: error.message,
        severity: "error",
      }));
    }
  };

  const handleAddQuestion = () => {
    setAddQuestion((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleAddQuestionClose = () => {
    setAddQuestion((prev) => ({
      ...prev,
      open: false,
      question: "",
      saveLoading: false,
      disabled: false,
    }));
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleQuestionSubmit = async (values) => {
    setAddQuestion((prev) => ({
      ...prev,
      saveLoading: true,
      disabled: true,
    }));

    try {
      const payload = {
        questions: [
          ...(referenceCheck.data?.questions || []),
          values.question,
        ].filter(Boolean),
      };

      const response = await PutReferenceCheck(matchId, payload);
      fetchInterviewKitData();
      handleAddQuestionClose();
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: response.message,
        severity: "success",
      }));
    } catch (error) {
      setAddQuestion((prev) => ({
        ...prev,
        saveLoading: false,
        disabled: false,
      }));
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: error.message,
        severity: "error",
      }));
    }
  };

  const handleDeleteClose = () => {
    setDeleteDialog((prev) => ({
      ...prev,
      open: false,
      content: "",
      index: null,
      loading: false,
    }));
  };

  const handleDeleteQuestion = (item, index) => {
    setDeleteDialog((prev) => ({
      ...prev,
      open: true,
      loading: false,
      content: item,
      index: index,
    }));
  };

  const handleDelete = async () => {
    setDeleteDialog((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const payload = {
        questions: referenceCheck.data?.questions.filter(
          (_, i) => i !== deleteDialog.index
        ),
      };
      const response = await PutReferenceCheck(matchId, payload);
      fetchInterviewKitData();
      handleDeleteClose();
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: "Questions deleted successfully",
        severity: "success",
      }));
    } catch (error) {
      setDeleteDialog((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: error.message,
        severity: "error",
      }));
    }
  };

  return (
    <CustomDiv
      height={"100vh"}
      background={"#F6F8FB"}
      display={"flex"}
      overflowY={"auto"}
    >
      <CommonGrid2
        width={"100%"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.35rem 1rem 1.35rem 1.35rem"}
      >
        <Breadcrumbs breadCrumbData={breadCrumbData} />
        <CommonGrid2
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          padding={"1rem 0px 0px 0px"}
        >
          <CustomDiv
            display={"flex"}
            width={"max-content"}
            alignItems={"center"}
            gap={"0rem"}
            justifyContent={"center"}
            customStyle={{
              flexDirection: "column",
            }}
          >
            <Typography variant="h3">
              {candidateName
                ? `${candidateName}'s Reference Check`
                : "Reference Check"}
            </Typography>
            <Typography
              variant="subtitle2"
              fontWeight={500}
              color={"#475467"}
              marginTop={"5px"}
            >
              {jobTitle || ""}
            </Typography>
          </CustomDiv>
          <CommonGrid2 display={"flex"} gap={"1rem"}>
            <CommonButton
              value={"Back"}
              startIcon={<BackArrowIco />}
              gap={"0px"}
              variant="outlined"
              color="#344054"
              padding={"8px 1.5rem"}
              fontWeight={"700"}
              fontSize={"15px"}
              border={"#D0D5DD"}
              width="auto"
              customStyle={{
                "&:hover svg path": {
                  stroke: "#fff",
                },
              }}
              onClick={() => navigate(-1)}
            />

            <CommonButton
              value={"Add Questions"}
              padding={"8px 16px"}
              fontWeight={600}
              fontSize={"14px"}
              onClick={handleAddQuestion}
            />
          </CommonGrid2>
        </CommonGrid2>

        <CommonGrid2 marginTop={"2rem"}>
          {referenceCheck.loading
            ? Array.from({ length: 3 }).map((_, index) => (
                <HandleSkeletion
                  key={index}
                  height="50px"
                  width="100%"
                  transform={"scale(1)"}
                  margin="1rem 0px"
                />
              ))
            : referenceCheck?.data &&
              referenceCheck?.data?.questions?.map((item, index) => (
                <CommonGrid2
                  key={index}
                  width="100%"
                  border="1px solid rgba(0, 0, 0, 0.12)"
                  background="#fff"
                  borderRadius="10px"
                  height="fit-content"
                  padding="12px 15px 10px"
                  marginTop="1rem"
                >
                  <CommonGrid2
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    gap={"1rem"}
                  >
                    <Typography variant="body2" fontWeight={600}>
                      {index + 1}. {item}
                    </Typography>

                    <CustomDiv
                      onClick={() => handleDeleteQuestion(item, index)}
                      customStyle={{
                        cursor: "pointer",
                      }}
                    >
                      <DeleteIco stroke="#D80027" />
                    </CustomDiv>
                  </CommonGrid2>

                  <Typography>-</Typography>
                </CommonGrid2>
              ))}
        </CommonGrid2>
      </CommonGrid2>

      <AddQuestion
        addQuestion={addQuestion}
        handleAddQuestionClose={handleAddQuestionClose}
        handleSubmit={handleQuestionSubmit}
      />
      <SkillDeleteDialog
        deleteDialog={deleteDialog.open}
        handleDeleteDialogClose={handleDeleteClose}
        handleDeleteSkill={handleDelete}
        buttonLoading={deleteDialog.loading}
        title={"Delete Question"}
        content={deleteDialog.content}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
